/** Format enrolment/subscribers counts with thousands separators. Returns null when absent. */
export function formatAccountCount(value) {
  if (value == null) return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return n.toLocaleString('en-US');
}

export function accountHasSubscribers(account) {
  return account?.subscribers != null;
}

export function accountHasEnrolment(account) {
  return account?.enrolment != null;
}

export function datasetHasSubscribers(accounts) {
  return (accounts || []).some(accountHasSubscribers);
}

/** Sortable size value: prefer enrolment, then subscribers (for coalesced sorting). */
export function getAccountSizeSortValue(account) {
  if (account?.enrolment != null) return Number(account.enrolment);
  if (account?.subscribers != null) return Number(account.subscribers);
  return null;
}
